module.exports = __webpack_public_path__ + "img/16581310_L.1463166d.png";